import React, { useState, useEffect, useContext } from "react";
import { PermissionContext } from "../../contexts/PermissionContext";
import { AuthContext } from "../../contexts/AuthContext";
import Notification from "../../components/UI/Notification";

const EditPermission = ({ permissionId }) => {
  const { token } = useContext(AuthContext); // Token for authentication
  const { currentPermission, fetchPermissionDetails, editPermission } =
    useContext(PermissionContext); // PermissionContext methods
  const [newPermissionName, setNewPermissionName] = useState("");
  const [message, setMessage] = useState("");
  const [notification, setNotification] = useState(null);

  // Fetch permission details when the component loads
  useEffect(() => {
    fetchPermissionDetails(token, permissionId);
  }, [token, permissionId, fetchPermissionDetails]);

  // Set the initial permission name when currentPermission changes
  useEffect(() => {
    if (currentPermission) setNewPermissionName(currentPermission.name);
  }, [currentPermission]);

  // Handle permission update
  const handleUpdatePermission = async () => {
    setMessage("");
    try {
      await editPermission(token, permissionId, { name: newPermissionName });
      // setMessage("Permission updated successfully.");
      // setNotification("Permission updated successfully.");
      setNotification({
        message: "Permission updated successfully.",
        type: "success",
      });
    } catch (err) {
      // setMessage(err.message || "Failed to update permission.");
      // setNotification(err.message || "Failed to update permission.");
      setNotification({
        message: `${err.message || "Failed to update permission"}`,
        type: "error",
      });
    }
  };

  if (!currentPermission) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <p className="text-gray-600 text-lg">Loading permission details...</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4">
      {notification && (
        <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />
      )}
      <div className="w-full max-w-md bg-white rounded shadow-md p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Edit Permission</h2>

        {message && (
          <p
            className={`mb-4 text-sm font-medium ${
              message.includes("successfully")
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {message}
          </p>
        )}

        <div className="mb-4">
          <p className="text-gray-700 mb-2">
            <strong>Permission ID:</strong> {currentPermission.id}
          </p>
          <label className="block text-gray-700 font-medium mb-2" htmlFor="permissionName">
            Permission Name <span className='text-red-500'>*</span>
          </label>
          <input
            id="permissionName"
            type="text"
            value={newPermissionName}
            onChange={(e) => setNewPermissionName(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter new permission name"
          />
        </div>

        <button
          onClick={handleUpdatePermission}
          className="w-full bg-blue-600 text-white py-2 px-4 font-medium rounded-lg hover:bg-blue-700 transition duration-200"
        >
          Update Permission
        </button>
      </div>
    </div>
  );
};

export default EditPermission;
